var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.589,
    height: 42.077,
    viewBox: "0 0 40.589 42.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3037"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1104",
    d: "M29.367 43.028a2.4 2.4 0 0 1 0-4.8 2.371 2.371 0 0 1 1.106.27 1.938 1.938 0 0 1 .216.125 2.4 2.4 0 0 1-1.323 4.41m0-3.654a1.253 1.253 0 1 0 .688.207.843.843 0 0 0-.1-.062 1.247 1.247 0 0 0-.583-.145",
    transform: "translate(-17.742 -21.325)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1105",
    d: "M13.77 42.8H7.819V32.158h5.951v3.869h1.8l-.183.718a3 3 0 0 0-.092.738 2.951 2.951 0 0 0 .092.733l.183.72h-1.8zm-4.8-1.152h3.647v-3.866h1.54c-.009-.1-.011-.2-.011-.3s0-.2.011-.3h-1.54v-3.869H8.971z",
    transform: "translate(-7.819 -18.182)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1106",
    d: "M48.165 16.9 35.681 7.4l2.759-4.256 15.477 11.773zM37.229 7.133l11.143 8.474 3.128-1.078-12.769-9.714z",
    transform: "translate(-22.26 -3.144)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1107",
    d: "m67.049 42.913-2.989-2.274L68.408 35l2.951 2.241zm-1.693-2.371 1.475 1.144 3.245-4.186-1.514-1.185z",
    transform: "translate(-36.968 -19.656)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1108",
    d: "m43.4 29.794-7.709-5.867-1.942 2.227-.426-.581a3.06 3.06 0 0 0-1.136-.943l-.687-.33 1.869-2.141-4.952-3.769 2.879-3.786 12.78 9.724 4.909-1.786zm-7.868-7.436 7.653 5.823 2.462-3.193-1.769.644-12.369-9.4-1.479 1.942 5.017 3.819-1.727 1.976a4.555 4.555 0 0 1 .464.389z",
    transform: "translate(-18.494 -9.086)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1109",
    d: "M76.031 36.819c-.377-2.261-.775-2.805-.887-2.919l-.112-.081a.811.811 0 0 0-.532-.052c-.015-1.392-.1-1.757-.506-2.167a.952.952 0 0 0-.705-.281 3.253 3.253 0 0 0-1.824 1.049c-.084.084-2.055 2.113-1.66 6.861.225 2.7-2.938 6.552-3 6.626 0 0-.043.047-.046.053s-.328-.125-.711-1.466c-.136-.476-.232-.885-.316-1.241-.33-1.409-.513-2.185-2.241-2.876-1.11-.444-1.689-.487-2-.15a.646.646 0 0 0-.115.668c.082.536.783 5.174 1.14 8.747.4 3.977 1.63 5.258 4.072 6.48a3.359 3.359 0 0 1 1.683 3.387l.857.121a4.2 4.2 0 0 0-2.151-4.278c-2.24-1.12-3.236-2.173-3.6-5.792-.34-3.4-.988-7.747-1.127-8.668a4.9 4.9 0 0 1 .92.292c1.31.524 1.405.929 1.72 2.271.086.367.185.79.326 1.281.38 1.33.827 1.992 1.407 2.083a.914.914 0 0 0 .875-.392c.14-.169 3.42-4.163 3.166-7.215-.3-3.635.89-5.512 1.289-6.029a24.163 24.163 0 0 0 .162 5.019c.366 1.465-.524 4.837-1.6 6.988l.774.387c1.175-2.35 2.075-5.943 1.664-7.585a29.026 29.026 0 0 1-.1-5.588 1 1 0 0 1 .439-.164c.052-.02.069.014.083.028.243.242.257.539.257 2.761h.055a5.338 5.338 0 0 0-.054.8c0 .053.364 5.293-.734 7.851l-1.15 2.685.8.341 1.15-2.685c1.179-2.749.817-8.031.8-8.223a2.8 2.8 0 0 1 .13-1 10.8 10.8 0 0 1 .544 2.225c.355 2.129-.325 7.1-.382 7.511-.12.44-1.676 6.141-2.38 8.573a10.708 10.708 0 0 0 2.5 6.777l.611-.612c-1.758-1.758-2.356-5.465-2.279-5.925.731-2.523 2.375-8.551 2.391-8.612l.011-.053c.036-.23.776-5.469.386-7.811z",
    transform: "translate(-35.555 -17.746)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBlock);
export default __webpack_public_path__ + "static/media/Camera_Block.c475d519b803e90866cd07ee2f9a4fe4.svg";
export { ForwardRef as ReactComponent };